<template lang="html">
  <div class="details">
    <div class="activityDesc" v-html="activityInfoData.home_register_desc"></div>

    <div class="prize">
      <img class="prizeTitleImg" src="../../assets/image/customActivity/ic_welfare.png" alt="">

      <div class="prizeCon">
        <div class="prizeList" v-for="(a, aIndex) in prizeData" :key="aIndex">
          <img class="prizeImg" :src="a.cover" alt="">

          <div class="prizeIntroduce" :class="{prizeIntroduceElse: !a.is_availability}">
            <p class="prizeName">{{a.title}}</p>
            <p class="prizeCondition">邀请{{a.invite_num}}人解锁</p>
            <p class="prizePeople">已邀请 <span>{{a.has_invite_num}}</span> 人</p>
          </div>

          <div class="receiveAwardBtn" v-show="a.is_availability" @click="getAvailability(a.prize_id)">立即领取</div>
        </div>
      </div>
    </div>
    
    <div class="inviteUserList">
      <div class="inviteUser" v-for="b in inviteData.slice(0, Math.max(...this.peopleNumber))" :key="b.id">
        <img class="inviteUserHeader" :src="b.avatar" alt="">
        <p class="inviteUserName">{{b.username.slice(0,3) + '...'}}</p>
      </div>
    
      <div class="inviteUser" v-for="(c, cIndex) in max" :key="cIndex">
        <img class="inviteUserHeader" src="../../assets/image/customActivity/ic_add.png" alt="">
        <p class="inviteUserName">待邀请</p>
      </div>
    </div>
    
    <div class="inviteBtn" @click="getInvite">
      <p>{{inviteData.length >= Math.max(...this.peopleNumber) ? '已完成' : '立即邀请'}}</p>
    </div>
    <img class="invitationRulesImg" :src="activityInfoData.invitation_rules_img" alt="">
    
    <div class="footerBtn" :class="{elseFooterBtn: !activityInfoData.home_button_link}">
      <p class="iCloudBtn" :class="{iCloudBtnElse: inviteData.length >= Math.max(...this.peopleNumber)}" v-show="activityInfoData.home_button_link" @click="getVisitor">
        <img :src="activityInfoData.home_button_img" alt="">
      </p>
      <p class="inviteFriendsBtn" v-show="inviteData.length < Math.max(...this.peopleNumber)" :class="{elseinviteFriendsBtn: !activityInfoData.home_button_link}" @click="getReceiveAward">邀请好友</p>
    </div>

    <div v-show="pickupMethodShow" class="pickupMethod">
      <div class="pickupMethodCon">
        <div class="pickupMethodHeader">
          <p>领取奖品</p>
          <img src="../../assets/image/customActivity/close_ic.png" alt="" @click="pickupMethodShow = false">
        </div>

        <div class="wechatIdGet" v-if="claimPrizeData.redemption_method == 1">
          <div class="wechatNumber">
            <p>微信号</p>
            <div class="qrCodeNumber">
              {{claimPrizeData.redemption_info}}
            </div>
          </div>
          <div class="wechatIdBtn" @click="copeText(claimPrizeData.redemption_info)">复制微信号</div>
          <p class="wechatHint">复制微信号，添加微信后领奖品</p>
        </div>

        <div class="qrCodeGet" v-else>
          <img class="qrCodeImg" :src="claimPrizeData.redemption_info" alt="">
          <!-- <div class="copyQrCodeBtn" @click="downloadImg(claimPrizeData.redemption_info)">保存二维码</div> -->
          <p class="wechatHint">长按识别二维码，添加微信后领取奖品</p>
        </div>
      </div>
    </div>

    <!-- 提示框 -->
    <div v-show="hintShow" class="hintMod">
      <p>{{hintCon}}</p>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import WxShare from '@/utils/wxshare';
  import { pagebase } from '@/utils/http.js';

  export default {
    data() {
      return {
        activityId: this.$route.query.aid,
        channelId: this.$route.query.channel || 0,
        activityInfoData: {},
        claimPrizeData: {},

        prizeData: [],
        inviteData: [],
        peopleNumber: [],
        max: '0',
        pickupMethodShow: false,

        hintTime: 1,
        hintShow: false,
        hintCon: '',
        
        pagebase: pagebase,
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getActivityInfo();
        this.getH5ActivityPrize();
      },

      getActivityInfo() {
        this.$http({
          url: '/api/getH5ActivityInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid') || '',
            token: Cookies.get('token') || '',
            activity_id: this.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityInfoData = res.data;
            
            if (this.activityInfoData.type == 1) {
              new WxShare().share({
                title: this.activityInfoData.title,
                desc: '海量资料免费领~',
                link: pagebase + '/#/customActivityInvite?inviteUid='+ Cookies.get('uid') +'&aid=' + this.activityId + '&channel=' + this.channelId,
                imgUrl: this.activityInfoData.cover,
              });
            } else if (this.activityInfoData.type == 3){
              new WxShare().share({
                title: this.activityInfoData.title,
                desc: '邀请好友，分享得好礼，快来帮我助力',
                link: pagebase + '/#/customActivityInvite?inviteUid='+ Cookies.get('uid') +'&aid=' + this.activityId + '&channel=' + this.channelId,
                imgUrl: this.activityInfoData.cover,
              });
            }
          }
        })
      },

      getH5ActivityPrize() {
        this.$http({
          url: '/api/getH5ActivityPrize',
          method: 'get',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            activity_id: this.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.prizeData = res.data.prize;
            this.inviteData = res.data.invite_data;

            for (var a = 0; a < this.prizeData.length; a++) {
              this.peopleNumber.push(this.prizeData[a].invite_num)
            }

            if (Math.max(...this.peopleNumber) >= this.inviteData.length) {
              this.max = Math.max(...this.peopleNumber) - this.inviteData.length;
            } else {
              this.max = 0
            }
          }
        })
      },

      getAvailability(pid) {
        this.$http({
          url: '/api/claimPrize',
          method: 'post',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            activity_id: this.activityId,
            prize_id: pid,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.claimPrizeData = res.data
            this.getH5ActivityPrize();
            this.pickupMethodShow = true;
          }
        })
      },

      // 复制微信号
      copeText(e) {
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', e)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        this.setHintCon('文本内容已复制')
      },

      // 保存二维码
      downloadImg(img) {
        const imageLink = document.createElement('a');
        imageLink.href = img;
        imageLink.download = 'images.jpg'; // 保存的文件名
        imageLink.target = '_blank';
        imageLink.click();
      },

      // 立即邀请
      getInvite() {
        if (Math.max(...this.peopleNumber) != this.inviteData.length) {
          this.$router.push({
            path: '/customActivityPoster',
            query: {
              aid: this.activityId,
              channel: this.channelId,
            }
          })
        }
      },

      getVisitor() {
        window.location.href = this.activityInfoData.home_button_link;
      },

      getReceiveAward() {
        this.$router.push({
          path: '/customActivityPoster',
          query: {
            aid: this.activityId,
            channel: this.channelId,
          }
        })
      },

      setHintCon(e) {
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },
    }
  }
</script>

<style lang="css" scoped>
  .details {
    box-sizing: border-box;
    padding-bottom: 10rem;
  }

  .activityCover {
    width: 100%;
    object-fit: contain;
  }
  
  .activityDesc {
    box-sizing: border-box;
  }
  
  .activityDesc >>> img {
    width: 100% !important;
  }

  .prize {
    position: relative;
    box-sizing: border-box;
    padding-bottom: 1rem;
    background: linear-gradient(#FFE7E7, #FFF6F6);
    margin-top: -1.5rem;
    border-radius: 1rem 1rem 0 0;
  }

  .prizeTitleImg {
    width: 100%;
    margin: 1.65rem 0;
  }

  .prizeCon {
    box-sizing: border-box;
    padding: 0 1.5rem;
  }

  .prizeList {
    box-sizing: border-box;
    padding: 1rem;
    border-radius: 1rem;
    display: flex;
    background-color: #FFFFFF;
    box-shadow: 0px 2px 4px 2px rgba(141, 105, 105, 0.11);
    margin-bottom: 1rem;
  }

  .prizeImg {
    width: 7rem;
    height: 7rem;
    border-radius: .8rem;
    object-fit: cover;
    margin-right: 1rem;
  }

  .prizeIntroduce {
    width: 15rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .prizeIntroduceElse {
    width: 24rem;
  }

  .prizeName {
    font-size: 1.6rem;
    color: #333333;
    font-weight: 600;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .prizeCondition {
    font-size: 1.4rem;
    color: #333;
  }

  .prizePeople {
    font-size: 1.3rem;
    color: #999999;
  }

  .prizePeople span {
    color: #F7443F;
  }

  .receiveAwardBtn {
    width: 8.4rem;
    height: 3rem;
    border-radius: 3rem;
    background: linear-gradient(#F7443F, #EA1A14);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    color: #FFFFFF;
    margin-top: 2.1rem;
    box-shadow: 0px 3px 4px 2px rgba(141, 105, 105, 0.11);
    margin-left: 1rem;
  }

  .inviteUserList {
    display: flex;
    flex-wrap: wrap;
    margin-top: 2.7rem;
  }

  .inviteUser {
    margin-bottom: 1.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .inviteUserHeader {
    width: 4.5rem;
    height: 4.5rem;
    margin: 0 1.49rem;
    border-radius: 4.5rem;
    object-fit: cover;
  }

  .inviteUserName {
    box-sizing: border-box;
    /* padding: 0 1.5rem; */
    width: 6rem;
    font-size: 1.2rem;
    color: #818181;
    margin-top: .3rem;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    text-align: center;
    white-space: nowrap;
  }

  .inviteBtn {
    box-sizing: border-box;
    padding: 0 2.2rem;
  }

  .inviteBtn p {
    width: 100%;
    height: 4.5rem;
    background: linear-gradient(#F7443F, #EA1A14);
    border-radius: 4.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.5rem;
    color: #FFF;
  }

  .invitationRulesImg {
    width: 100%;
    object-fit: contain;
    margin-top: 1.5rem;
  }

  .footerBtn {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0 2.2rem;
    padding-bottom: 3.4rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .elseFooterBtn {
    display: flex;
    justify-content: center;
  }

  .iCloudBtn {
    width: 15.3rem;
    height: 4.5rem;
    border-radius: 4.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }
  
  .iCloudBtnElse {
    width: 100%;
  }
  
  .iCloudBtn img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4.5rem;
  }

  .inviteFriendsBtn {
    width: 15.3rem;
    height: 4.5rem;
    border-radius: 4.5rem;
    background: linear-gradient(to top, #EA1A14, #F7443F);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  .elseinviteFriendsBtn {
    width: 100%;
  }

  .pickupMethod {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pickupMethodCon {
    width: 32.5rem;
    height: 37.85rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    box-sizing: border-box;
    padding: 1.5rem;
  }

  .pickupMethodHeader {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .pickupMethodHeader p {
    font-size: 1.7rem;
    font-weight: 600;
    margin-right: 8.85rem;
  }

  .pickupMethodHeader img {
    width: 2.5rem;
    height: 2.5rem;
    margin-top: .15rem;
  }

  /* 微信号 */
  .wechatIdGet {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5.3rem;
  }

  .wechatNumber {
    width: 24.85rem;
    height: 13.65rem;
    border-radius: 1rem;
    background-color: #F5F5F7;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wechatNumber p {
    font-size: 1.4rem;
  }

  .wechatNumber div {
    font-size: 2.2rem;
    font-weight: 600;
    margin-top: 1.45rem;
  }

  .wechatIdBtn {
    width: 21.9rem;
    height: 4.5rem;
    background: linear-gradient(to top, #EA1A14, #F7443F);
    border-radius: 4.5rem;
    margin-top: 3.7rem;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .wechatHint {
    font-size: 1.3rem;
    color: #999;
    margin-top: 1.65rem;
  }

  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 100;
  }

  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 1.3rem;
    color: #FFFFFF;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 二维码 */
  .qrCodeGet {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .qrCodeImg {
    width: 15rem;
    height: 15rem;
    margin-top: 4.5rem;
  }

  .copyQrCodeBtn {
    width: 21.9rem;
    height: 4.5rem;
    background: linear-gradient(to top, #EA1A14, #F7443F);
    border-radius: 4.5rem;
    margin-top: 3.7rem;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>